// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o4cFg","col":"styles_col__2b07T"};